export default __webpack_public_path__ + "static/media/ico_anadir.25c90897.svg";